<mat-form-field appearance="outline">
  <mat-label>Select date</mat-label>
  <mat-date-range-input [rangePicker]="picker" [formGroup]="range" >
    <input matStartDate placeholder="Start" >
    <input matEndDate placeholder="end">
  </mat-date-range-input>
  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
  <mat-date-range-picker #picker></mat-date-range-picker>
</mat-form-field>
